export default "__VITE_ASSET__k9R3N7LL__"